import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import loadingBarMiddleware from "./middlewares/loadingBarMiddleware";
import sessionMiddleware from "./middlewares/sessionMiddleware";
import * as storage from "./persistStore";
import reducer from "./reducers";
import sagas from "./sagas";

export const configureReduxStore = () => {
  let store = null;

  const saga = createSagaMiddleware();

  const rootReducer = combineReducers(reducer);

  let storedSession = storage.getItem(storage.STORAGE_KEY);

  if (
    !storedSession ||
    JSON.parse(storedSession).version !== process.env.REACT_APP_VERSION
  ) {
    store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
          thunk: false,
          serializableCheck: {
            ignoredActionPaths: ["payload.logo"],
            ignoredActions: [
              "uploads/uploadRequest",
              "userUploads/userUploadRequest",
            ],
          },
        }),
        saga,
        loadingBarMiddleware(),
        sessionMiddleware(),
      ],
    });
    const newState = JSON.stringify({
      version: process.env.REACT_APP_VERSION,
      state: storage.withoutUnsavedSlices(store.getState()),
    });
    storage.setItem(storage.STORAGE_KEY, newState);
  } else {
    storedSession = JSON.parse(storedSession);
    store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
          thunk: false,
          serializableCheck: {
            ignoredActionPaths: ["payload.logo"],
            ignoredActions: [
              "uploads/uploadRequest",
              "userUploads/userUploadRequest",
            ],
          },
        }),
        saga,
        loadingBarMiddleware(),
        sessionMiddleware(),
      ],
      // A request that was on its way when the page was left never answers.
      preloadedState: storage.withoutRequestsInFlight(storedSession.state),
    });
  }

  saga.run(sagas);

  store.subscribe(() => {
    const newState = JSON.stringify({
      state: storage.withoutUnsavedSlices(store.getState()),
      version: process.env.REACT_APP_VERSION,
    });
    storage.setItem(storage.STORAGE_KEY, newState);
  });

  return store;
};
